export default function guest({next, store, nextMiddleware}) {
    if (store.state.auth.status.loggedIn) {
        return next();
    }
    return nextMiddleware();
}